import { booleanAttribute, Component, EventEmitter, inject, Input, Output, TemplateRef } from '@angular/core';
import { IsMobileService } from '@shared/services/is-mobile.service';

@Component({
  selector: 'sigecom-new-list-item',
  template: `
    <div class="flex justify-between items-center min-w-full p-4 {{bgColor}} rounded-lg shadow-md relative"
      [ngClass]="{'border-[#C9C9C9] border-2' : outline, 'flex-col': (isMobile$ | async)}">
      <div class="flex flex-col w-full">
        <div #titleContainer class="flex items-start justify-start gap-4"
          [ngClass]="{'justify-between': (isMobile$ | async), 'pb-2':!(isMobile$ | async)}"
        >
          <sigecom-list-title [text]="title"/>

          <sigecom-menu-bar-item
            class="self-start"
            *ngIf="externalEdit.observed"
            title="Abrir em nova guia"
            icon="external-link"
            color="sigecom-info"
            (clickAction)="externalEdit.emit()"
          />

          <ng-container *ngIf="statusTemplate && !(isMobile$ | async)">
            <ng-container *ngTemplateOutlet="statusTemplate"></ng-container>
          </ng-container>

        </div>
        <ng-content select="[content]"></ng-content>
      </div>
      <div class="flex gap-4 items-end" [ngClass]="{'pt-3 w-full': (isMobile$ | async), 'justify-between': statusTemplate, 'justify-end': !statusTemplate}">
        <ng-container *ngIf="statusTemplate && (isMobile$ | async)">
          <ng-container *ngTemplateOutlet="statusTemplate"></ng-container>
        </ng-container>
        <ng-content select="[actions]"></ng-content>
      </div>
    </div>
  `,
})
export class NewListItemComponent {
  @Input() bgColor: string = 'bg-white';
  @Input() title: string = '';
  @Input({ transform: booleanAttribute }) outline: boolean = false;
  @Input() statusTemplate: TemplateRef<any> | null = null;
  @Output() externalEdit = new EventEmitter<void>();

  #isMobileService = inject(IsMobileService);

  isMobile$ = this.#isMobileService.isMobile$;
}
